/* eslint-disable no-prototype-builtins */
import componentHelper from '../../modules/component_helper.js';
import SelectOptionDisabler from '../../modules/select_option_disabler.js';

angular.module('vastdesk').
  component('targetedMacrosGroupToggle', {
    bindings: {
      formName: '@',
      formId: '@',
      targetedMacrosEnabled: '<',
      toggleClass: '@',
      contentIngestionEnabled: '<'
    },
    template: require("../templates/targetedMacrosGroupToggle.html"),
    controllerAs: '$targetedMacrosGroupToggleCtrl',
    controller: function () {

      const MACROS_MAPPING = {
        '{{CONTENT_ID}}': 'videoId',
        '{{CONTENT_TITLE}}': 'videoTitle',
        '{{CONTENT_SERIES}}': 'seriesName',
        '{{CONTENT_SEASON}}': 'season',
        '{{CONTENT_EPISODE}}': 'episode',
        '{{DURATION}}': 'contentLength',
        '{{CONTENT_CATEGORIES}}': 'contentCategoriesSet',
        '{{RATING}}': 'contentRating',
        '{{CONTENT_GENRE}}': 'genre',
        '{{CONTENT_PRODUCER_NAME}}': 'producer',
        '{{NETWORK_NAME}}': 'contentNetwork',
        '{{CHANNEL_NAME}}': 'contentChannel'
      };

      var self = this;
      var bodySelector = $('body');

      var macroSelectOptionDisabler = new SelectOptionDisabler(
        '.nested-fields:not([style*="display: none"]) .macro_param select'
      );

      var updateTargetedMacroFields = function (group) {
        macroSelectOptionDisabler.disableParamOptions(group);
      };

      var updateParameterListSelect = function (section, macroValue) {
        var parameterListSelect = section.find('.tm-parameter-lists select');
        parameterListSelect.trigger('tokenize:clear');

        if (parameterListSelect.tokenize2()) {
          parameterListSelect.tokenize2().options.dataSource = '/searches/parameter_lists?macro_param=' + encodeURI(macroValue || '');
        }
      };

      var updateParameterValueSelect = function (section, macroValue) {
        var parameterValueSelect = section.find('.content-api-select select');
        if (parameterValueSelect[0].tomselect) {
          // Destroy the old tomselect instance and recreate it with new load function, and preload functionality.
          parameterValueSelect[0].tomselect.destroy();
          $(parameterValueSelect[0]).defaultTomSelect();
          const ts = parameterValueSelect[0].tomselect;
          ts.clear(); // Clears selected options
          ts.clearOptions(); // Clears search results

          // We have to create a new load function here because of the url has to be dynamic based on macro field.
          ts.settings.load = function(query, callback) {
            var url = '/magnite_streaming_api/search?search=' + encodeURIComponent(query) + '&field=' + MACROS_MAPPING[macroValue];
            fetch(url)
              .then(response => response.json())
              .then(json => {
                ts.clearOptions(); // It appends results when disabling search so have to clear first
                callback(json);
              }).catch(()=>{
                callback();
              });
          };
        }
      };

      const updateApiSelect = (section) => {
        if (self.contentIngestionEnabled) {
          const macroValue = $(section.find('.macro_param select')).val();
          const listType = section.find('.list_type select').val();
          if (MACROS_MAPPING.hasOwnProperty(macroValue) && _.includes(['white_list', 'black_list'], listType)) {
            section.find('.default-values select option').remove();
            section.find('.default-values select').val([]).trigger('chosen:updated');
          } else {
            const contentApiSelect = section.find('.content-api-select select');
            contentApiSelect.trigger('tokenize:clear');
          }
        }
      };

      var handleMacroChange = function (section) {
        const sourceType = section.find("input[name*='[source_type]']:checked").val();
        const macroValue = section.find('.macro_param select').val();
        const nonDefaultValues = _.includes(['{{CONTENT_LIVESTREAM}}', '{{PRODUCTION_QUALITY}}', '{{CONTEXTUAL_SIGNALING}}'], macroValue);
        const listType = section.find('.list_type select').val();

        if (!!self.contentIngestionEnabled && MACROS_MAPPING.hasOwnProperty(macroValue) && _.includes(['white_list', 'black_list'], listType)) {
          section.find('.content-api-select').toggleClass('hidden', sourceType !== 'values' || nonDefaultValues);
          section.find('.default-values').addClass('hidden');
          updateParameterValueSelect(section, macroValue);
        }
        else {
          section.find('.content-api-select').addClass('hidden');
          section.find('.default-values').toggleClass('hidden', sourceType !== 'values' || nonDefaultValues);
          updateApiSelect(section);
        }

        section.find('.production-quality-values').toggleClass('hidden', sourceType !== 'values' || macroValue !== '{{PRODUCTION_QUALITY}}');
        section.find('.livestream-value').toggleClass('hidden', sourceType !== 'values' || macroValue !== '{{CONTENT_LIVESTREAM}}');
        section.find('.magnite-content-targeting').toggleClass('hidden', sourceType !== 'values' || macroValue !== '{{CONTEXTUAL_SIGNALING}}');
        section.find('.tm-parameter-lists').toggleClass('hidden', sourceType !== 'list');
        section.find('.btn-list').toggleClass('hidden', 
          macroValue === '{{CONTENT_LIVESTREAM}}' || macroValue === '{{CONTEXTUAL_SIGNALING}}');

        updateParameterListSelect(section, macroValue);

        setTimeout(function () {
          section.find(".list_type select option[value*='white_list_partial_match']").prop('disabled', nonDefaultValues);
          section.find(".list_type select option[value*='black_list_partial_match']").prop('disabled', nonDefaultValues);
          section.find(".list_type select").trigger('chosen:updated');
        }, 0);
      };

      var visibleTargetedMacroDivs = function () {
        return $('#collapse-content-targeting .associationGroup:not([style*="display: none"])').not('.hidden');
      };

      bodySelector.on('cocoon:after-insert', '#targeted_macros', function (e, addedTargetedMacro) {
        $.each($(addedTargetedMacro).find('select:not([data-ajax]):not([data-dynamic-chosen])'), function (index, select) {
          $(select).defaultChosen();
        });

        $.each($(addedTargetedMacro).find('select[data-dynamic-chosen]'), function (index, select) {
          $(select).dynamicChosen();
        });

        $.each($(addedTargetedMacro).find('select[data-ajax][data-tom-select]'), function(index, select){
          $(select).defaultTomSelect();
        });

        $.each($(addedTargetedMacro).find('select[data-ajax]:not([data-tom-select])'), function(index, select){
          $(select).defaultTokenize();
        });

        var group = $(e.target).closest('.associationGroup');
        updateTargetedMacroFields(group);
      });

      bodySelector.on('cocoon:after-remove', '#targeted_macros', function (e) {
        var group = $(e.target).closest('.associationGroup');
        updateTargetedMacroFields(group);

        if (visibleTargetedMacroDivs().length < 1) {
          $('#collapse-content-targeting .groupedAssociationButtons .btn-false').click();
        }
      });

      bodySelector.on('change', '#targeted_macros .macro_param select', function (e) {
        var section = $(this).parents('.targeted-macros');

        var group = $(e.target).closest('.associationGroup');
        updateTargetedMacroFields(group);
        handleMacroChange(section);

        section.find('.default-values select option').remove();
        section.find('.default-values select').val([]).trigger('chosen:updated');
      });

      this.updateApiSelectOnChange = function (e) {
        const section = $(this).parents('.targeted-macros');
        updateApiSelect(section);
      };

      this.updateSectionFieldsOnChange = function (e) {
        const section = $(this).parents('.targeted-macros');
        handleMacroChange(section);
      };

      bodySelector.on('change', '#targeted_macros .default-values select', this.updateApiSelectOnChange);
      bodySelector.on('change', '#targeted_macros .content-api-select select', this.updateApiSelectOnChange);
      bodySelector.on('change', "#targeted_macros input[name*='[source_type]']", this.updateSectionFieldsOnChange);
      bodySelector.on('change', "#targeted_macros .list_type select", this.updateSectionFieldsOnChange);

      bodySelector.on('click', '#collapse-content-targeting .groupedAssociationButtons .btn-true', function () {
        setTimeout(function () {
          if (visibleTargetedMacroDivs().length === 0) {
            $('#collapse-content-targeting #add_targeted_macro').trigger('click');
          }
        }, 100);
      });

      this.allCustomOptions = componentHelper.allCustomOptions();

      this.setTargetedMacrosEnabled = function (value) {
        self.targetedMacrosEnabled = value;

        $('.' + self.toggleClass).toggleClass('hidden', !value);
      };

      this.$onInit = function () {
        self.setTargetedMacrosEnabled(self.targetedMacrosEnabled);
      };

      $('#targeted_macros .targeted-macros').each(function () {
        handleMacroChange($(this));
      });

      setTimeout(function () {
        $('#targeted_macros .associationGroup').each(function (i, group) {
          updateTargetedMacroFields(group);
        });
      }, 0);
    }
  });
